import Vue from 'vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default class Notifier {
  success(message) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'Sucesso',
        icon: 'CheckIcon',
        variant: 'success',
        text: message,
      },
    });
  }

  error(message) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'Erro',
        icon: 'XOctagonIcon',
        variant: 'danger',
        text: message,
      },
    });
  }

  warning(message) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'Atenção',
        icon: 'AlertTriangleIcon',
        variant: 'warning',
        text: message,
      },
    });
  }

  info(message) {
    Vue.$toast({
      component: ToastificationContent,
      props: {
        title: 'Informação',
        icon: 'InfoIcon',
        variant: 'info',
        text: message,
      },
    });
  }
}
